// extracted by mini-css-extract-plugin
module.exports = {"container":"Dadata_container__3fzJZ","suggestions":"Dadata_suggestions__lNTbh","suggestion":"Dadata_suggestion__3-q27","option":"Dadata_option__2R_ga"};